<template>
  <div class="activity">
    <h4>
      精彩活动
      <span @click="$router.push('/home/activities')">更多</span>
    </h4>
    <ul class="activityList">
      <li @click="$router.push('/live')">
          <img src="http://www.cippe.com.cn/miniprogram/huodong01.png" alt=""/>
      </li>
      <li @click="$jumpWeb('https://oil.zhenweievents.com/')">
          <img src="http://www.cippe.com.cn/miniprogram/huodong02.png" alt=""/>
      </li>
      <li @click="$router.push('/home/activities/ccpit')">
          <img src="http://www.cippe.com.cn/miniprogram/huodong03.png" alt=""/>
      </li>
      <li @click="$router.push('/home/activities/seminar')">
          <img src="http://www.cippe.com.cn/miniprogram/huodong04.png" alt=""/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .activityList{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }
  .activityList li{
    width: 49%;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 5px;
    border-radius: 5px;
  }
  
  .activityList li:focus{
    opacity: .7;
  }
</style>